module.exports = __webpack_public_path__ + "static/media/McKinseySans-Light.af5dc81b.woff";